(function () {
    'use strict';

    angular
        .module('employeeControllers')
        .controller('EmployeeController', Controller);

    Controller.$inject = ['$sce', '$scope', '$state', 'topBar', 'authenticatedUser', 'employee'];

    function Controller($sce, $scope, $state, topBar, authenticatedUser, employee) {

        $scope.employee = employee;

        var employeeNameHtml = '<i style="font-size: 1.3em; color: #777" class="fa fa-user"></i>&nbsp;' + employee.DisplayName;

        $scope.updateTopBar = updateTopBar;

        function updateTopBar(title, titleCssClasses) {
            var topBarHtml = employeeNameHtml;

            if (!$state.is('profile.employee')) {
                topBarHtml += '&nbsp;<i style="color: #777" class="fa fa-chevron-right"></i>&nbsp;' +
                              '<i style="font-size: 1.3em; color: #777" class="' +
                              titleCssClasses + '"></i>&nbsp;' +
                              title;
            }

            topBar.setTitle($sce.trustAsHtml(topBarHtml));
        }
    }
})();